/**
 * Reprise du flux spectateur : quand des egress relancés redeviennent lisibles, le back publie un
 * SESSION_UPDATE portant `availableQualities`. C'est le seul signal exploitable pour rebrancher le
 * player : une playlist HLS terminée (#EXT-X-ENDLIST) ne redémarre jamais d'elle-même côté hls.js,
 * et l'URL du flux change au redémarrage d'un egress (le back isole désormais chaque tentative dans
 * son propre chemin), donc le refetch du playback est obligatoire pour récupérer la nouvelle playlist.
 *
 * La liste vide compte aussi : elle annonce que les quatre flux sont tombés. Il n'y a alors rien à
 * rebrancher, mais le refetch fait redescendre les `ready` et laisse le player afficher la coupure
 * au lieu de rester collé à une image figée.
 */
export function isStreamAvailabilityUpdate(
  messageName: string | undefined,
  data: unknown,
): boolean {
  if (messageName !== 'event-message' || !data || typeof data !== 'object') {
    return false;
  }
  const payload = data as { type?: unknown; availableQualities?: unknown };
  return payload.type === 'SESSION_UPDATE' && Array.isArray(payload.availableQualities);
}
